
<template>
  <div>
    <el-dialog :visible.sync="wakeDialogVisible" title="" width="450px" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="wakeMain">
        <i class="el-icon-warning"></i>
        <div class="content">{{ $t('app.auto_343_12743d28') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doNotLogin">{{ $t('app.wakeDialogDeferLogin') }}</el-button>
        <el-button type="primary" @click="dealWithFreeze">{{ $t('app.wakeDialogWakeNow') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="wakeSecondDialogVisible" title="" width="450px" :show-close="false"
      :close-on-click-modal="false">
      <div class="wakeMain">
        <i class="el-icon-warning"></i>
        <div class="content">
          {{ $t('app.wakeDialogSecondMessage', { campusId, phone }) }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wakeSecondDialogVisible = false">{{ $t('app.wakeDialogDeferHandle') }}</el-button>
        <el-button type="primary" @click="wakeSecondDialogConfirm">{{ $t('app.wakeDialogConfirmed') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAccountFreezeDetail,
  getAccountDisableDetail,
  wakeUpAccount
} from "@/api/AddEmpolyee";

export default {
  data() {
    return {
      wakeDialogVisible: false,
      wakeSecondDialogVisible: false,
      campusId: '',
      phone: ''
    };
  },
  methods: {
    // 入口函数
    // "systemType"1.经销商系统 2.代理商系统 3.分析师系统
    // userId
    // accountId (统一账号时)
    async startUp(options, ...params) {
      this.options = options
      this.userId = options.userId
      this.loginParams = params
      this.type = 0

      const resFreeze = await this.getAccountFreezeDetail(options)
      const resDisable = await this.getAccountDisableDetail(options)

      this.resFreeze = resFreeze
      this.resDisable = resDisable
      console.log(resFreeze, resDisable, 'res')

      // 无冻结 走禁用逻辑
      if (resFreeze == 0) {
        if (resDisable == 0) {
          return true
        } else {
          this.$message.error(this.$t('app.auto_691_87642a19'))
        }
      } else {
        this.wakeDialogVisible = true
      }

      return false
    },
    async startUpMounted(options) {
      this.userId = options.userId
      this.type = 1

      const resFreeze = await this.getAccountFreezeDetail(options)
      const resDisable = await this.getAccountDisableDetail(options)

      this.resFreeze = resFreeze
      this.resDisable = resDisable
      console.log(resFreeze, resDisable, 'res')

      // 无冻结 走禁用逻辑
      if (resFreeze == 0) {
        if (resDisable == 0) {
          return true
        } else {
          this.$message.error(this.$t('app.auto_691_87642a19'))
        }
      } else {
        this.wakeDialogVisible = true
      }

      return false
    },
    wakeUpAccount() {
      let param = { userId: this.userId }
      this.options.accountId&& (param = this.options)
      return wakeUpAccount(param).then(({ code, message, data }) => {
        return data
      })
    },
    getAccountDisableDetail(options) {
      let params = JSON.parse(JSON.stringify(options))
      delete params.freezeNeedNotSystemType
      return getAccountDisableDetail(params).then(({ code, message, data }) => {
        console.log(code, message, data, 'getAccountDisableDetail')

        // 兜底
        if (code == 0 && !data) {
          return 0
        }

        return data.type
      })
    },
    getAccountFreezeDetail(options) {
      let params = JSON.parse(JSON.stringify(options))
      if (params.freezeNeedNotSystemType) {
        delete params.systemType
      }
      delete params.freezeNeedNotSystemType

      return getAccountFreezeDetail(params).then(({ code, message, data }) => {
        console.log(code, message, data, 'getAccountFreezeDetail')

        // 兜底：如果 data 为空，返回 0
        if (!data) {
          console.warn('getAccountFreezeDetail 返回的 data 为空')
          return 0
        }

        const { campusId, phone, type } = data
        this.campusId = campusId
        this.phone = phone

        return type
      })
    },
    wakeSecondDialogConfirm() {

    },
    doNotLogin(){
      this.wakeDialogVisible = false
      if(this.type){
        this.$emit('logout')
      }
    },
    async dealWithFreeze() {
      // this.wakeDialogVisible = false
      // this.wakeSecondDialogVisible = true
      if (this.type) {
        const wakeUpAccount = await this.wakeUpAccount()
        if (wakeUpAccount) {
          this.wakeDialogVisible = false
          this.$message.success(this.$t('app.auto_693_bd7f79f4'))
        } else {
          this.$message.error(this.$t('app.auto_694_777ce4cd'))
        }
      } else {
        const wakeUpAccount = await this.wakeUpAccount()
        if (wakeUpAccount) {
          this.$emit("toDoLogin", ...this.loginParams);
        } else {
          this.$message.error(this.$t('app.auto_694_777ce4cd'))
        }
        this.wakeDialogVisible = false
      }
    }
  },
  components: {

  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.wakeMain {
  padding: 20px 20px 5px;
  display: flex;

  .content {
    font-size: 18px;
    color: black;
    font-weight: 400;
  }

  .el-icon-warning {
    margin-right: 10px;
    margin-top: 2px;

    &::before {
      font-size: 24px;
      color: #4a83e8;
      content: '\e7a3';
    }
  }
}



:deep(.el-dialog__header) {
  padding: 0px !important;
}

:deep(.el-dialog__body) {
  padding: 0px !important;
}
</style>